
import { defineComponent } from 'vue';
import { OfferListMode } from './models/OfferListMode';
import { estateAgencyService } from '@/estate-agency/EstateAgencyService';
import { estateAgentService } from '@/estate-agent/EstateAgentService';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import AdOfferList from './components/AdOfferList.vue';
import { accountService } from '../account/AccountService';
import { mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import config from '@/shared/constants/config';

export default defineComponent({
  components: {
    ResizableImage,
    AdOfferList,
  },
  props: {
    mode: Number,
    estateAgencyId: Number,
    frontUserId: Number,
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      estateAgency: null as null | any,
      estateAgent: null as null | any,
      isConfirmEmailSent: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    isUserList(): boolean {
      return this.mode === OfferListMode.userlist;
    },
    isFavorite(): boolean {
      return this.mode === OfferListMode.favorite;
    },
    isHistory(): boolean {
      return this.mode === OfferListMode.history;
    },
    isDeveloperProject(): boolean {
      return this.mode === OfferListMode.developerproject;
    },
    headerHasAddon(): boolean {
      return (this.estateAgency && this.estateAgency.logoRelativeUrl) || (this.estateAgent && this.estateAgent.photoRelativeUrl);
    },
  },
  async created() {
    try {
      if (this.mode === OfferListMode.estateagency && this.estateAgencyId) {
        this.estateAgency = (await estateAgencyService.getById(this.estateAgencyId)).data;
      } else if (this.mode === OfferListMode.estateagent && this.frontUserId) {
        this.estateAgent = (await estateAgentService.getById(this.frontUserId)).data;
      }
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    async sendConfirmEmail() {
      try {
        this.isLoading = true;
        await accountService.resetConfirmEmail();
        this.isConfirmEmailSent = true;
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
